"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var r in e) {
    t[r] = e[r];
  }
}(exports, function (t) {
  var e = {};function r(i) {
    if (e[i]) return e[i].exports;var n = e[i] = { i: i, l: !1, exports: {} };return t[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
  }return r.m = t, r.c = e, r.d = function (t, e, i) {
    r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var i = Object.create(null);if (r.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var n in t) {
      r.d(i, n, function (e) {
        return t[e];
      }.bind(null, n));
    }return i;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "", r(r.s = 113);
}({ 113: function _(t, e, r) {
    t.exports = r(114);
  }, 114: function _(t, e, r) {
    "use strict";
    r.r(e), r.d(e, "PasswordValidator", function () {
      return n;
    });var i = "data-rs-password-validator";
    var n = function () {
      function n(t) {
        _classCallCheck(this, n);

        this.element = t, this.input = this.element.querySelector('input[type="password"]'), this.checklist = this.getChecklist, this.minChars = this.element.getAttribute(this.attributes.minChars), this.minCharsReg = this.getMinimumCharacters, this.addEventHandlers();
      }

      _createClass(n, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.input.addEventListener("keyup", function () {
            _this.validateInput();
          }), this.input.addEventListener("blur", function () {
            _this.validateInput();
          }), this.input.addEventListener("focus", function () {
            _this.showChecklist();
          });
        }
      }, {
        key: "validateInput",
        value: function validateInput() {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = this.checklist[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _t = _step.value;
              this.input.value.match(this.validators[_t.name]) ? _t.element.classList.add(this.classes.valid) : _t.element.classList.remove(this.classes.valid);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }, {
        key: "showChecklist",
        value: function showChecklist() {
          this.element.parentNode.querySelector("[" + this.attributes.checklist + "]").removeAttribute("hidden");
        }
      }, {
        key: "attributes",
        get: function get() {
          return { validate: i + "-validate", checklist: i + "-checklist", minChars: i + "-min-chars" };
        }
      }, {
        key: "classes",
        get: function get() {
          return { valid: "valid" };
        }
      }, {
        key: "getMinimumCharacters",
        get: function get() {
          if (this.minChars) {
            var _t2 = this.minChars;return new RegExp(".{" + _t2 + ",}");
          }return (/.{8,}/
          );
        }
      }, {
        key: "validators",
        get: function get() {
          return { minSign: this.minCharsReg, useUpper: /[A-Z]/, useDigit: /[0-9]/, useChar: /[a-z]/, noSymbol: /^([^ /\\,#&<>:';"?=%]+)$/ };
        }
      }, {
        key: "getChecklist",
        get: function get() {
          var t = [],
              e = this.element.parentNode.querySelectorAll("[" + this.attributes.validate + "]");var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = e[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _r = _step2.value;
              t.push({ name: _r.dataset.rsPasswordValidatorValidate, element: _r });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          return t;
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[" + i + "]";
        }
      }]);

      return n;
    }();
  } }));